import { Badge } from "antd"; // adjust import if needed

interface TimewritingStatusBadgeProps {
	status?: "approved" | "rejected" | "resubmitted" | string;
	className?: string;
}

function TimewritingStatusBadge({
	status,
	className,
}: TimewritingStatusBadgeProps): React.ReactNode {
	switch (status) {
		case "approved":
			return (
				<Badge
					className={className}
					status="success"
					text="Approved"
					style={{
						display: "flex",
						alignItems: "center",
						pointerEvents: "auto",
						color: "inherit",
					}}
				/>
			);
		case "rejected":
			return (
				<Badge
					className={className}
					status="error"
					text="Rejected"
					style={{
						display: "flex",
						alignItems: "center",
						pointerEvents: "auto",
						color: "inherit",
					}}
				/>
			);
		case "resubmitted":
			return (
				<Badge
					className={className}
					color="cyan"
					text="Resubmitted for review"
					style={{
						display: "flex",
						alignItems: "center",
						pointerEvents: "auto",
						color: "inherit",
					}}
				/>
			);
		default:
			return <></>;
	}
}

export default TimewritingStatusBadge;
